var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{on:{"click":_vm.convert}},[_vm._v("Generar shape")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }